import { createListCollection } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from '@/components/ui/field';
import {
  SelectContent,
  SelectItem,
  SelectRoot,
  SelectTrigger,
  SelectValueText,
} from '@/components/ui/select';

export function GiftSelectionLimit({
  productCount,
  value,
  onChange,
  portalled = true,
}: {
  productCount: number;
  value?: number;
  onChange: (value: number) => void;
  portalled?: boolean;
}) {
  const { t } = useTranslation();
  const collection = useMemo(
    () =>
      createListCollection({
        items: Array.from({ length: Math.min(5, productCount) }, (_, i) => ({
          label: String(i + 1),
          value: String(i + 1),
        })),
      }),
    [productCount]
  );
  return (
    <Field label={t('flows.properties.gift.maxSelectableProducts')}>
      <SelectRoot
        collection={collection}
        value={value === undefined ? [] : [String(value)]}
        onValueChange={({ value: selection }) => {
          if (selection[0]) onChange(Number(selection[0]));
        }}
        size="sm"
        positioning={{ strategy: 'fixed' }}
      >
        <SelectTrigger>
          <SelectValueText placeholder={value === undefined ? undefined : String(value)} />
        </SelectTrigger>
        <SelectContent portalled={portalled}>
          {collection.items.map((item) => (
            <SelectItem key={item.value} item={item}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </SelectRoot>
    </Field>
  );
}
